const el = (sel, par) => (par || document).querySelector(sel);
const els = (sel, par) => (par || document).querySelectorAll(sel);
const elNew = (tag, prop) => Object.assign(document.createElement(tag), prop);
const mod = (n, m) => (n % m + m) % m;

const hero = (elHero) => {

  const animation = 500;
  const pause = parseInt(document.getElementById("hero-slider").getAttribute("data-time"));

  // Or use something like: const animation = Math.abs(elHero.dataset.heroAnimation ?? 500);

  const elHeroSlider = el(".hero-slider", elHero);
  const elsSlides = els(".hero-slide", elHeroSlider);
  const elsBtns = [];

  let itv; // Autoslide interval
  let tot = elsSlides.length; // Total slides
  let c = 0;

  if (tot == 1) {
    elsSlides[0].classList.add("is-active");
  }

  if (tot < 2) return; // Not enough slides. Do nothing.

  // Methods:
  const anim = (ms = animation) => {
    const cMod = mod(c, tot);
    // Move slider
    elHeroSlider.style.transitionDuration = `${ms}ms`;
    elHeroSlider.style.transform = `translateX(${(-c - 1) * 100}%)`;
    // Handle active classes (slide and bullet)
    elsSlides.forEach((elSlide, i) => elSlide.classList.toggle("is-active", cMod === i));
    elsBtns.forEach((elBtn, i) => elBtn.classList.toggle("is-active", cMod === i));
  };

  const prev = () => {
    if (c <= -1) return; // prevent blanks on fast prev-click
    c -= 1;
    anim();
  };

  const next = () => {
    if (c >= tot) return; // prevent blanks on fast next-click
    c += 1;
    anim();
  };

  const goto = (index) => {
    c = index;
    anim();
  };

  const play = () => {


    itv = setInterval(next, pause + animation);
    elPlay.style.display = "none";
    elPause.style.display = "block";

  };

  const stop = () => {
    clearInterval(itv);
    elPlay.style.display = "block";
    elPause.style.display = "none";
  };

  // Buttons:
  // Play btn
  const elPlay = elNew("button", {
    className: "hero-play",
    innerHTML: "<span class='sr-only'>Starta karusellen</span><i aria-hidden='true' class='fa fa-play'></i>",
    onclick: () => {
      elHero.classList.add('playing');
      elHero.classList.remove('pausing');
      play();
      next();
    },
  });
  // Pause btn
  const elPause = elNew("button", {
    className: "hero-pause",
    innerHTML: "<span class='sr-only'>Pausa karusellen</span><i aria-hidden='true' class='fa fa-pause'></i>",
    onclick: () => {
      elHero.classList.add('pausing');
      elHero.classList.remove('playing');
      stop();
    },
  });

  // Backaknapp, används inte än
  // const elPrev = elNew("button", {
  //   type: "button",
  //   className: "hero-prev",
  //   innerHTML: "<span>Prev</span>",
  //   onclick: () => prev(),
  // });

  //Next button
  // const elNext = elNew("button", {
  //   type: "button",
  //   className: "hero-next",
  //   innerHTML: "<i class='material-icons'>chevron_right</i>",
  //   ariaLabel: `Gå till nästa bild`,
  //   onclick: () => next(),
  // });

  // Navigation:

  const elNavigation = elNew("div", {
    className: "hero-navigation",
  });


  // Navigation bullets:

  for (let i = 0; i < tot; i++) {
    const elBtn = elNew("button", {
      type: "button",
      className: "hero-bullet",
      ariaLabel: `Gå till bild ${i + 1}`,
      onclick: () => goto(i),
    });
    elsBtns.push(elBtn);
  }

  // Events:

  // Infinite slide effect:
  elHeroSlider.addEventListener("transitionend", () => {
    if (c <= -1) c = tot - 1;
    if (c >= tot) c = 0;
    // console.log(c);

    anim(0); // quickly switch to "c" slide (with animation duration 0)

    const slides = elHeroSlider.querySelectorAll('.hero-slide');
    if (slides[c + 1].classList.contains('yellow')) {
      elHeroSlider.classList.add('yellow-is-active');
    } else {
      elHeroSlider.classList.remove('yellow-is-active');
    }
  });

  // Pause on pointer enter:
  // elHero.addEventListener("pointerenter", () => stop());
  // elHero.addEventListener("pointerleave", () => play());

  // Init:

  // Insert UI elements:

  if (document.querySelector('.autoplay')) {
    elPlay.style.display = "none";
    elPause.style.display = "block";
    elNavigation.append(elPlay);
    elNavigation.append(elPause);
  }
  else {
    elPlay.style.display = "block";
    elPause.style.display = "none";
    elNavigation.append(elPlay);
    elNavigation.append(elPause);
  }


  elNavigation.append(...elsBtns);

  //Next button
  // elNavigation.append(elNext);

  elHero.append(elNavigation);

  // Clone first and last slides (for "infinite" slider effect)
  elHeroSlider.prepend(elsSlides[tot - 1].cloneNode(true));
  elHeroSlider.append(elsSlides[0].cloneNode(true));


  // Initial slide, "0" for no animation
  anim(0);

  // Start autoplay
  if (document.querySelector('.autoplay')) {
    setTimeout(() => {
      play();
    }, 10);
  }
};
els(".hero").forEach(hero);
